import clsx from "clsx";
import {AlertTriangle, RefreshCw, WifiOff} from "lucide-react";
import {DataState} from "../../../shared/components/DataState";
import {StatusBadge} from "../../../shared/components/StatusBadge";
import {
    KIND_LABELS,
    OFFLINE_COPY,
    OFFLINE_TITLE,
    appTextsErrorMessage,
    formatShortDateTime,
    pluralRu,
    queryWaitState,
    sectionCountsLabel,
} from "../appTextsContracts";
import {useTranslation} from "../../../shared/i18n";


export const AppTextsSectionList = ({query, sections, activeName, onSelect}) => {
    const {t} = useTranslation();
    const wait = queryWaitState(query);
    if (wait === "offline") {
        return <div className="content-readonly-note"><WifiOff size={16} /><span>{OFFLINE_TITLE}. {OFFLINE_COPY}</span></div>;
    }
    if (wait === "loading") {
        return (
            <div aria-label={t("sections.content.p119")} className="content-media-loading content-texts-loading">
                <span /><span /><span /><span />
            </div>
        );
    }
    if (query.isError) {
        return (
            <div className="content-texts-state">
                <DataState title={t("sections.content.p120")} copy={appTextsErrorMessage(query.error)} />
                <button className="admin-row-action" onClick={() => query.refetch()} type="button"><RefreshCw size={14} /> {t("sections.content.p70")}</button>
            </div>
        );
    }
    if (!sections.length) {
        return <DataState title={t("sections.content.p121")} copy={t("sections.content.p122")} />;
    }

    return (
        <nav aria-label={t("sections.content.p123")} className="content-texts-sections">
            {sections.map((item) => {
                const active = item.name === activeName;
                const warnings = Number(item.warning_count) || 0;
                const stale = Number(item.stale_key_count) || 0;
                const updated = formatShortDateTime(item.updated_at);
                return (
                    <button
                        aria-current={active ? "true" : undefined}
                        className={clsx("content-texts-section", active && "is-active")}
                        key={item.name}
                        onClick={() => onSelect(item.name)}
                        type="button"
                    >
                        <span className="content-texts-section-head">
                            <strong>{item.title || item.name}</strong>
                            <small>{KIND_LABELS[item.kind] || item.kind}</small>
                        </span>
                        <code className="content-texts-mono">{item.name}</code>
                        <span className="content-texts-section-counts">{sectionCountsLabel(item)}</span>
                        {warnings || item.base_missing || stale ? (
                            <span className="content-texts-section-badges">
                                {warnings ? (
                                    <StatusBadge tone="warning">
                                        <AlertTriangle aria-hidden="true" size={11} /> {warnings}
                                        <span className="content-texts-sr-only"> {pluralRu(warnings, [t("sections.content.p124"), t("sections.content.p125"), t("sections.content.p126")])}</span>
                                    </StatusBadge>
                                ) : null}
                                {item.base_missing ? <StatusBadge tone="danger">{t("sections.content.p127")}</StatusBadge> : null}
                                {stale ? <StatusBadge tone="danger">{t("sections.content.p128")} {stale}</StatusBadge> : null}
                            </span>
                        ) : null}
                        {updated ? <small className="content-texts-section-updated">{t("sections.content.p129")} {updated}</small> : null}
                    </button>
                );
            })}
        </nav>
    );
};
